// extracted by mini-css-extract-plugin
export default {"menuBlock":"WG-z","title":"XG-z","nav":"YG-z","flexCell":"ZG-z","facetLink":"_G-z"};